import template from './webskedTime.html';
import modalTemplate from './webskedTimeModal.html';
import modalCtrl from './webskedTimeModalController';

function webskedTime() {
  return {
    restrict: 'E',
    template,
    controller: 'WebskedTimeController',
    scope: {
      story: '=story'
    }
  };
}

function WebskedTimeController($scope, $uibModal, moment, analyticsService, timezoneService) {
  $scope.$watch('story.dates.websked', (dateValue) => {
    // wait for story to populate with date values
    if (dateValue) {
      $scope.webskedTime = moment($scope.story.dates.websked * 1000)
        .tz(timezoneService.userTimezone)
        .format(timezoneService.userTimeHourFormat === 12 ? 'L h:mm a' : 'L H:mm');
    }
  });

  // Main function to trigger the modal
  $scope.openModal = () => {
    // Set these before triggering the modal, being used in the template
    if ($scope.story.dates.websked) {
      $scope.story.dates.webskedDateUpdate = timezoneService.getTzDate(
        $scope.story.dates.websked * 1000
      );
      $scope.story.dates.webskedTimeUpdate = timezoneService.getTzDate(
        $scope.story.dates.websked * 1000
      );
    } else {
      $scope.story.dates.webskedUpdate = moment().add(4, 'hours').valueOf();
      $scope.story.dates.webskedDateUpdate = timezoneService.getTzDate(new Date());
      $scope.story.dates.webskedTimeUpdate = timezoneService.getTzDate(new Date());
    }

    // Removing animation class if exists
    $scope.etaUpdated = false;

    // Send analytics
    analyticsService.trackEvent('Planned publish time', 'Considering updating the planned publish time');

    // Actual opening of modal
    $uibModal.open({
      template: modalTemplate,
      controller: 'WebskedTimeModalController',
      // Passing in the $scope so we can share the same data (story) 
      // between this controller and modal's controller
      scope: $scope,
      // Important class for all styles, needs to be on top element of modal
      windowClass: 'twp-eta-dropdown'
    }).result
      .then(() => {
        // Add the animation class in template
        $scope.etaUpdated = true;
      });
  };
}

const controllerArray = [
  '$scope',
  '$uibModal',
  'moment',
  'analyticsService',
  'timezoneService',
  WebskedTimeController
];

export default function (ngModule) {
  ngModule.directive('webskedTime', webskedTime);
  ngModule.controller('WebskedTimeController', controllerArray);
  modalCtrl(ngModule);
}
